<template>
<div>
  <template v-if="item">
    <template v-if="item.model">
      <cart-item :cart-item="item"
                 can-mutate-store
                 @save="saveCartItem(item.index)"
                 v-slot="{
                   cartItem,

                   showPrintVisual,
                   highlightedLocation,
                   showErrors: showCartItemErrors,
                   errors: cartItemErrors,

                   availablePrintLocations,
                   textileSizes,
                   textileDensities,
                   number,
                   minNumber,
                   prices,
                   resultPrice,
                   totals: cartItemTotals,
                   total: cartItemTotal,
                   totalPerItem: cartItemTotalPerItem,
                   thumb,
                   isBag,
                   errorsList: cartItemErrorsList,
                   hasErrors: cartItemHasErrors,

                   save,
                   update,
                   updateComponentProp,
                   removeCartItem,
                   setHighlightedLocation,
                   onNumberFieldInput,
                   onTypeReset,
                   onModelReset,
                   onModelReplace,
                   onSliderReady,
                 }"
        >
          <div class="wph-cart-item wph-mb-12 lg:wph-flex">
            <div class="wph-cart-item__main lg:wph-w-2/3 wph-px-4 lg:wph-pr-12 lg:wph-pl-0">
              <div class="wph-cart-item__sections-container wph-pt-6 wph-overflow-x-hidden">
                <cart-item-breadcrumbs :product-type="cartItem.type" :product-model="cartItem.model"
                                       @product-type-reset="onTypeReset"
                                       @product-model-reset="onModelReset"
                                       class="wph-mb-4 wph-text-center wph-text-gray-500"
                ></cart-item-breadcrumbs>
                <h2 class="wph-text-center wph-text-accent-dark wph-text-3xl">{{ cartItem.model.title }}</h2>
                <div class="wph-mb-5 wph-text-center">
                  <a :href="`https://pr-tex.ru/product/${cartItem.model.model}/`" class="wph-text-sm wph-text-blue-lighter hover:wph-text-blue-light" target="_blank" title="Ссылка откроется в новой вкладке">
                    <span class="wph-underline">Подробная информация</span>
                    <svg fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" viewBox="0 0 24 24" class="wph-inline-block wph-w-4 wph-h-4 wph--mt-3"><path d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" title="Ссылка откроется в новой вкладке"></path></svg>
                  </a>
                </div>
                <div class="wph-cart-item__section-switch wph-mb-3 wph-text-center">
                  <button role="button" @click="updateComponentProp('showPrintVisual', false)"
                          class="wph-cart-item__section-switch-button wph-rounded-l-full"
                          :disabled="!showPrintVisual"
                  >Фотографии</button>
                  <button role="button" @click="updateComponentProp('showPrintVisual', true)"
                          class="wph-cart-item__section-switch-button wph-rounded-r-full wph--ml-px"
                          :disabled="showPrintVisual"
                  >Нанесение</button>
                </div>
                <div v-show="!showPrintVisual">
                  <div class="wph-cart-item__section wph-cart-item__gallery">
                    <textile-preview ref="textile-preview" :product="cartItem" :color="cartItem.color.id"
                                    @slider-ready="onSliderReady"
                    ></textile-preview>
                  </div>
                  <div v-if="cartItem.model.description" v-html="cartItem.model.description" class="wph-mt-4 wph-px-4 wph-text-gray-700"></div>
                </div>
                <div v-show="showPrintVisual" class="wph-cart-item__section wph-cart-item__print-places wph-pt-6 wph-px-8">
                  <textile-visual-print-location-picker
                    :product="cartItem"
                    :highlighted-location="highlightedLocation"
                    :available-print-locations="availablePrintLocations"
                    :update-product="update"
                    :update-product-prop="updateComponentProp"
                  />
                </div>
              </div>
            </div>
            <div class="wph-cart-item__sidebar
                wph-mt-10 md:wph-mt-0
                wph-text-gray-600 wph-rounded-t-20 lg:wph-rounded-none
                lg:wph-w-1/3">
              <div class="wph-cart-item__section wph-cart-item__color-and-sizes
                  wph-pt-10 wph-px-0"
              >
                <div class="wph-px-4 wph-pb-8 lg:wph-px-8 wph-border-b wph-border-gray-200">
                  <template v-if="!isBag">
                    <div class="wph-mb-1 wph-text-accent-dark wph-text-xl">Цена:
                      <span class="wph-text-3xl">{{ resultPrice | money }}</span>
                      <span v-if="resultPrice < prices.max" class="wph-text-xl wph-line-through wph-inline-block wph-ml-1 wph-text-gray-500">{{ prices.max | money }}</span>
                    </div>
                    <span class="wph-text-xl wph-text-accent-dark wph-inline-block wph-mr-4">Тираж:</span>
                    <increment-input :value="number" :min="minNumber" :step="10"
                                     @input="onNumberFieldInput"
                                     class="wph-w-24"
                    ></increment-input>
                    <div class="wph-mt-2 wph-text-sm">
                      <app-checkbox :value="cartItem.pack" @change="update({ pack: $event })">Индивидуальная упаковка</app-checkbox>
                    </div>
                  </template>
                  <template v-else>
                    <size-picker
                      :product="cartItem"
                      :sizes="cartItem.sizes"
                      :update-product="update"
                    >
                      <template #errors>
                        <p v-show="showCartItemErrors && cartItemErrorsList.indexOf('insufficientNumber') > -1"
                           class="wph--mt-2 wph-mb-4 wph-text-red"
                        >Минимальный тираж <strong>{{ minNumber }} шт.</strong></p>
                      </template>
                    </size-picker>
                    <div v-for="(size) in cartItem.sizes" :key="size.data.id" class="wph-mt-4">
                      <div class="wph-flex wph-items-baseline">
                        <span class="wph-text-gray-500">{{ size.data.label }}</span>
                        <increment-input :value="size.number" :step="100"
                                         @input="update({ number: $event }, size)"
                                         class="wph-w-24 wph-ml-4"
                        ></increment-input><span class="wph-inline-block wph-ml-2 wph-text-sm wph-text-gray-500">шт.</span>
                      </div>
                    </div>
                    <div class="wph-pt-8 wph-mt-8 wph-border-t wph-border-gray-200">
                      <h3 class="wph-text-2xl wph-text-accent-dark wph-mb-4">Плотность:</h3>
                      <multiselect :options="textileDensities"
                                   :value="cartItem.density"
                                   @input="update({ density: $event })"
                                   :hideSelected="true"
                                   :searchable="false"
                                   track-by="id"
                                   label='label'
                                   placeholder="Выбрать плотность"
                                   v-bind="multiselectDefaultLabels"
                                   class="wph-mb-3"
                      ></multiselect>
                    </div>
                  </template>
                </div>
                <color-picker :cart-item="cartItem"
                              :update-item-color="update"
                              class="wph-px-4 wph-py-8 lg:wph-px-8 wph-border-b wph-border-gray-200"
                />
                <print-location-picker ref="print-location-picker"
                                       :product="cartItem"
                                       :print-locations="cartItem.printLocations"
                                       :update-product="update"
                                       :update-product-prop="updateComponentProp"
                                       class="wph-pt-8 wph-border-b wph-border-gray-200"
                >
                  <template #errors>
                    <p v-show="showCartItemErrors && cartItemErrorsList.indexOf('zeroPrintLocations') > -1"
                       class="wph--mt-2 wph-mb-4 wph-text-red"
                    >{{ cartItemErrors['zeroPrintLocations'] }}</p>
                  </template>
                </print-location-picker>
                <div>
                  <print-location v-for="location in cartItem.printLocations" :key="location.data.id"
                                  :product="cartItem"
                                  :location="location"
                                  :number="number"
                                  :can-mutate-store="true"
                                  :show-errors="showCartItemErrors"
                                  :max-attachments="5"
                                  @update="update($event.propsToUpdate, $event.item)"
                                  @mouseover.native="setHighlightedLocation(location.data.id)"
                                  @mouseleave.native="setHighlightedLocation('')"
                                  v-slot="{
                                    showErrors: showPrintLocationErrors,
                                    maxAttachments,

                                    errors: printLocationErrors,

                                    allowedTechnologies,
                                    allowedSquares,
                                    errorsList: printLocationErrorsList,
                                    hasErrors: printLocationHasErrors,

                                    selectedColors,
                                    needsSubstrate,
                                    totalSelectedColorsNumber,
                                    maxSelectedColorsNumber,
                                    onTechnologySelect,
                                    costStrategy: printCostStrategy,

                                    onSquareSelect,
                                    onColorSelectionChange,
                                    onSquareWidthInput,
                                    onSquareHeightInput,
                                    updateCost,
                                    updatePriceMultiplier,
                                    onFilesUpload,
                                    detachFile,
                                    onMetallizedThreadChange,
                                  }"
                  >
                    <component :is="printCostStrategy"
                               :product="cartItem"
                               :location="location"
                               :productNumber="number"
                               :textile-color="cartItem.color"
                               :selectedColors="selectedColors"
                               :needsSubstrate="needsSubstrate"
                               :totalSelectedColorsNumber="totalSelectedColorsNumber"
                               @cost-update="updateCost"
                               @price-multiplier-update="updatePriceMultiplier"
                               v-slot="{}"
                    >
                      <div class="wph-textile-print-location wph-pt-6 wph-pb-8 wph-px-4 lg:wph-px-8 wph-border-b wph-border-gray-200">
                        <h4 class="wph-text-sm wph-mb-1">{{ location.data.name }}</h4>
                        <multiselect :options="allowedTechnologies"
                                     :value="location.technology"
                                     @input="onTechnologySelect"
                                     :searchable="false"
                                     :allowEmpty="false"
                                     label="label"
                                     placeholder="Технология"
                                     v-bind="multiselectDefaultLabels"
                                     deselectLabel=""
                        ></multiselect>
                        <div v-if="location.technology.id === 'embroidery'" class="wph-mt-2 wph-mb-4">
                          <app-checkbox :value="location.metallizedThread" @change="onMetallizedThreadChange">
                            <span class="wph-text-sm">Металлизированная нить</span>
                          </app-checkbox>
                        </div>
                        <div class="wph-flex wph-mt-2">
                          <div v-if="location.technology.allowsColorPick" class="wph-w-20 wph-mr-2">
                            <h5 class="wph-text-sm wph-mb-1">Цвета</h5>
                            <print-colors-dropdown
                              :location="location"
                              :needs-substrate="needsSubstrate"
                              :max-selected-colors-number="maxSelectedColorsNumber"
                              :update-product="update"
                              @color-selection-change="onColorSelectionChange"
                            />
                          </div>
                          <div class="wph-flex-auto" :class="{ 'wph-pl-4': location.technology.id === 'bagPrint' }">
                            <h5 class="wph-text-sm wph-mb-1">Площадь нанесения<span v-if="location.square.units">,
                              <span class="wph-font-bold">{{ location.square.units }}</span>
                            </span>
                            </h5>
                            <div v-if="location.technology.id === 'bagPrint'"
                                 class="wph-flex wph-items-center"
                            >
                              <increment-input :value="location.w" :min="10" :max="location.square.maxW" :step="10"
                                               @input="onSquareWidthInput"
                                               class="wph-w-20"
                              ></increment-input>
                              <div class="wph-px-2 wph-text-sm wph-text-gray-500">&times;</div>
                              <increment-input :value="location.h" :min="10" :max="location.square.maxH" :step="10"
                                               @input="onSquareHeightInput"
                                               class="wph-w-20"
                              ></increment-input>
                            </div>
                            <div v-else class="wph-flex">
                              <multiselect :options="allowedSquares"
                                           :value="location.square"
                                           @input="onSquareSelect"
                                           :searchable="false"
                                           :allowEmpty="false"
                                           label="label"
                                           placeholder="Площадь нанесения"
                                           v-bind="multiselectDefaultLabels"
                                           select-label=""
                                           deselectLabel=""
                                           @select="onSquareSelect"
                              ></multiselect>
                              <div v-if="location.square.id === 'custom'"
                                   class="wph-flex wph-items-center wph-ml-4"
                              >
                                <increment-input :value="location.w" 
                                  :min="1" 
                                  :max="location.square.max[location.data.id] ? location.square.max[location.data.id].w : location.square.max.default.w" 
                                  :step="1"
                                  @input="onSquareWidthInput"
                                  class="wph-w-20" 
                                />
                                <div class="wph-px-2 wph-text-sm wph-text-gray-500">&times;</div>
                                <increment-input :value="location.h"
                                  :min="1" 
                                  :max="location.square.max[location.data.id] ? location.square.max[location.data.id].h : location.square.max.default.h" 
                                  :step="1"
                                  @input="onSquareHeightInput"
                                  class="wph-w-20"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                        <div>
                          <div v-if="location.files.length" class="wph-mt-4">
                            <h4 class="wph-mb-2 wph-text-sm">Загруженные файлы
                              <span v-show="location.files.length === maxAttachments">(макс. {{ maxAttachments }})</span>
                            </h4>
                            <ul>
                              <li v-for="file in location.files" :key="file.storedName"
                                  class="wph-text-sm wph-text-black wph-whitespace-no-wrap wph-overflow-x-hidden"
                                  style="text-overflow: ellipsis"
                              >
                                <span title="Открепить" @click="detachFile(file)"
                                      class="wph-inline-block wph-mr-1 wph-text-red wph-text-sm wph-cursor-pointer"
                                >&times;</span>
                                {{ file.originalName }}
                              </li>
                            </ul>
                          </div>
                          <app-send url="upload"
                                    :headers="{ 'Content-Type': 'multipart/form-data' }"
                                    @success="onFilesUpload($event)"
                                    v-slot="{
                                      sending,
                                      response,
                                      error,

                                      send,
                                    }"
                          >
                            <div v-if="maxAttachments - location.files.length > 0" class="wph-mt-2">
                              <div v-show="!sending">
                                <file-picker multiple
                                             :max="maxAttachments - location.files.length"
                                             :button-text="location.files.length ? 'Добавить файлы' : 'Прикрепить файлы'"
                                             @form-data-ready="send($event)"
                                ></file-picker>
                                <em class="wph-block wph-text-xs">Макет и другие вспомогательные файлы</em>
                              </div>
                              <p v-show="sending"><em class="wph-text-sm wph-text-gray-500">Загружаем...</em></p>
                            </div>
                          </app-send>
                        </div>
                        <div v-show="showPrintLocationErrors && printLocationHasErrors"
                             class="wph-text-red wph-pt-1"
                        >
                          <ul class="wph-list-disc wph-list-inside">
                            <li v-for="error in printLocationErrorsList" :key="error">{{ printLocationErrors[error] }}</li>
                          </ul>
                        </div>
                      </div>
                    </component>
                  </print-location>
                </div>
              </div>
              <div class="wph-px-4 wph-py-8 lg:wph-px-8 wph-bg-accent-dark wph-text-gray-200 wph-text-right">
                <template v-if="!isBag">
                  Сумма:
                  <p>Тираж:
                    <span class="wph-text-2xl">{{ cartItemTotals.current | money }}</span>
                    <span v-show="cartItemTotals.current < cartItemTotals.max"
                          class="wph-line-through wph-inline-block wph-ml-1 wph-text-gray-500"
                    > {{ cartItemTotals.max | money }}</span>
                  </p>
                  <p>Нанесение:
                    <span class="wph-text-2xl">{{ cartItemTotals.print | money }}</span>
                  </p>
                  <p>Упаковка:
                    <span class="wph-text-2xl">{{ cartItemTotals.packing | money }}</span>
                  </p>
                </template>
                <p class="wph-text-white wph-text-3xl"
                   :class="!isBag ? ['wph-mt-5', 'wph-pt-4', 'wph-border-t', 'wph-border-gray-700'] : ''"
                >Итого:
                  {{ cartItemTotal | money }}
                </p>
                <p v-show="cartItemTotalPerItem" class="wph--mt-1 wph-text-sm wph-text-gray-500">{{ cartItemTotalPerItem | money }} за шт.</p>
                <p class="wph-mt-3 wph-flex wph-items-baseline wph-justify-end">
                  <button role="button" @click="cancelEdit"
                          class="wph-text-sm wph-text-red-dark wph-text-gray-500 hover:wph-text-red-dark"
                  >{{ item.virtualId ? 'Отменить изменения' : 'Отмена' }}</button>
                  <button role="button" @click="save"
                          class="wph-button wph-button--small wph-ml-4"
                  >{{ item.virtualId ? 'Сохранить' : 'В корзину' }}</button>
                </p>
                <p class="wph-mt-1 wph-text-red" v-show="showCartItemErrors && cartItemHasErrors">Необходимо устранить ошибки, указанные выше</p>
              </div>
            </div>
          </div>
        </cart-item>
    </template>
    <product-picker v-else
                    :type="item.type"
                    @model-picked="onCartItemModelReplace(item, $event)"
                    @cancel="restoreCartItem(item)"
    />
  </template>
  <template v-else>
    <div v-if="saveMessage" class="wph-text-center">
      <p class="wph-mb-4">{{ saveMessage }}</p>
      <button role="button" @click="goToCart"
              class="wph-button"
      >Оформить заказ</button>
      <p class="wph-mt-4 wph-mb-3 wph-text-gray-500 wph-uppercase">или</p>
      <h2 class="wph-text-2xl">Добавить еще</h2>
    </div>
    <product-picker @model-picked="onModelPick" />
  </template>
</div>
</template>

<script>
import { mapMutations } from 'vuex'

import CartItem from './CartItem'
import ProductPicker from './ProductPicker'
import CartItemBreadcrumbs from './CartItemBreadcrumbs'
import TextilePreview from './TextilePreview'
import TextileVisualPrintLocationPicker from './TextileVisualPrintLocationPicker'
import SizePicker from './SizePicker'
import ColorPicker from './ColorPicker'
import PrintLocationPicker from './PrintLocationPicker'
import PrintLocation from './PrintLocation'
import PrintColorsDropdown from './PrintColorsDropdown'
import AppCheckbox from './Checkbox'
import IncrementInput from './IncrementInput'
import Multiselect from 'vue-multiselect'
import MultiselectDefaultLabels from '../mixins/MultiselectDefaultLabels'
import FilePicker from './FilePicker'
import Send from './requests/Send'

export default {
  name: "CartItemEditor",
  components: {
    CartItem,
    ProductPicker,
    CartItemBreadcrumbs,
    TextilePreview,
    TextileVisualPrintLocationPicker,
    SizePicker,
    ColorPicker,
    PrintLocationPicker,
    PrintLocation,
    PrintColorsDropdown,
    AppCheckbox,
    IncrementInput,
    Multiselect,
    FilePicker,
    AppSend: Send,
  },
  mixins: [MultiselectDefaultLabels],
  computed: {
    item() {
      return this.$store.state.cart.editedItem
    },
    saveMessage() {
      return this.$store.state.cart.saveMessage
    },
  },
  methods: {
    ...mapMutations([
      'createCartItem',
      'addCartItem',
      'replaceCartItem',
      'updateCartItem',
      'restoreCartItem',
      'clearEditedCartItem',
      'clearSaveMessage',
    ]),
    onModelPick(payload) {
      this.createCartItem(payload)
    },
    onCartItemModelReplace(item, propsToUpdate) {
      if (item.backup && item.backup.model && (item.backup.model.model === propsToUpdate.model.model)) {
        this.restoreCartItem(item)
        return
      }
      this.onModelPick(propsToUpdate)
    },
    saveCartItem(index) {
      this.item.virtualId ? this.replaceCartItem(index) : this.addCartItem()
      this.$emit('added-to-cart')
    },
    cancelEdit() {
      const itemId = this.item.virtualId
      this.clearEditedCartItem()
      if (itemId) {
        this.$emit('go-to-cart')
      }
    },
    goToCart() {
      this.clearSaveMessage()
      this.$emit('go-to-cart')
    },
  },
}
</script>